import { MessageCache } from "@hermes/intl";

export const messageCache = new MessageCache({
  load: (baseName: string) =>
    import(`./translations/${baseName}.json`)
      .then((module) => module.default)
      .catch(() => undefined),
});
